/**
 * Combines the words into a readable sentence like: apple, orange, banana and lemon
 */
export const combineWords = (words: string[]) => words.join(', ').replace(/,(?!.*,)/gim, ' and');
